export const SIDES = ["buy", "sell"] as const;

export type Side = (typeof SIDES)[number];

export const CRYPTO_ORDER_TYPES = ["market", "limit", "stop_limit"] as const;

export type CryptoOrderType = (typeof CRYPTO_ORDER_TYPES)[number];

export const CRYPTO_QUANTITY_TYPES = ["base", "quote"] as const;

export type CryptoQuantityType = (typeof CRYPTO_QUANTITY_TYPES)[number];

export const CRYPTO_ORDER_TYPE_OPTIONS: {
  label: string;
  value: CryptoOrderType;
}[] = [
  { label: "Market", value: "market" },
  { label: "Limit", value: "limit" },
  { label: "Stop Limit", value: "stop_limit" },
];

export const CRYPTO_TIME_IN_FORCE = ["gtc", "ioc"] as const;

export type CryptoTimeInForce = (typeof CRYPTO_TIME_IN_FORCE)[number];

export const CRYPTO_TIME_IN_FORCE_OPTIONS: {
  label: string;
  subLabel?: string;
  value: CryptoTimeInForce;
  orderTypes: CryptoOrderType[];
}[] = [
  {
    label: "GTC",
    subLabel: "Expires in 90 days",
    value: "gtc",
    orderTypes: ["market", "limit", "stop_limit"],
  },
  {
    label: "IOC",
    subLabel: "Immediate or Cancel",
    value: "ioc",
    orderTypes: ["market", "limit", "stop_limit"],
  },
];
